module.exports = __webpack_public_path__ + "img/doubleSideTriangleVertical.3301498f.svg";